import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import HelpQuestion from '@helsenorge/designsystem-react/components/HelpQuestion';
import HelpTrigger from '@helsenorge/designsystem-react/components/HelpTrigger';
import { TriggerHelpItemEvent } from '../hjelpeskuff';
const HjelpetriggerComponent = React.forwardRef(({ resources, sporsmalstekst, classes, tjenesteNavn, hjelpetekstId, helpBubbleIsExpanded, size, stopPropagation, useCustomEvent, onClick, }, ref) => {
    if (!resources) {
        return null;
    }
    const handleHelpClick = (event) => {
        if (stopPropagation && event) {
            event.stopPropagation();
        }
        if (useCustomEvent) {
            const helpElement = {
                hjelpetekstId: hjelpetekstId,
                tjenesteNavn,
                triggerComponentId: hjelpetekstId, // denne skal egentlig være unik
            };
            const triggerHelpItemEvent = new CustomEvent(TriggerHelpItemEvent, {
                detail: helpElement,
            });
            window.dispatchEvent(triggerHelpItemEvent);
        }
        if (onClick) {
            onClick();
        }
    };
    let trigger;
    if (sporsmalstekst) {
        trigger = (_jsx(HelpQuestion, { className: classes, onClick: handleHelpClick, ref: ref, children: sporsmalstekst }));
    }
    else {
        trigger = (_jsx(HelpTrigger, { className: classes, onClick: handleHelpClick, ariaLabel: resources.helpTriggerLabel, selected: helpBubbleIsExpanded, size: size, ref: ref }));
    }
    return _jsx("span", { className: "js-prosesshjelp", children: trigger });
});
HjelpetriggerComponent.displayName = 'HjelpetriggerComponent';
export default HjelpetriggerComponent;
